module.exports = __webpack_public_path__ + "static/12-e611583c7a850b93f6f51dbd76753fbf.jpg";